import {Component, Input, EventEmitter, OnDestroy, OnInit, Output} from '@angular/core';
import {FullOffer} from '../../../../models/offer/full-offer';
import {ActivatedRoute} from '@angular/router';
import {Subscription} from 'rxjs';
import {StockApiService} from '../../../../services/stock-api.service';
import {SwiperConfigInterface} from 'ngx-swiper-wrapper';
import {BasicOffer} from '../../../../models/offer/basic-offer';
import {CrystalLightbox, LightboxComponent} from 'ngx-crystal-gallery';
import {AngularStickyThingsModule} from '@w11k/angular-sticky-things';
import {QueryStringService} from '../../../../services/query-string.service';
import {DefaultImagePipe} from '../../../../tools/default-image.pipe';
import {ObservedOfferService} from '../../../../services/observed-offer.service';
import {ComparedOfferService} from '../../../../services/compared-offer.service';
import {ShareComponent} from '../../../../modals/share/share.component';
import {AppComponent} from '../../../../app.component';
import {LocalStorageService} from '../../../../services/local-storage.service';
import {AdobeService} from '../../../../services/adobe.service';
import {ErrorHandler} from '../../../../tools/error-handler';
import {BlueKaiService} from '../../../../services/blue-kai.service';
import {TitleService} from '../../../../services/title.service';
import {LabelProviderService} from '../../../../services/labelProvider.service';
import {DomSanitizer} from '@angular/platform-browser';
import {TrackingService} from '../../../../services/tracking.service';
import {environment} from '../../../../../environments/environment';
import {BrandService} from '../../../../services/brand.service';
import {NewsletterService} from '../../../../services/newsletter.service';
import {TawkToChatService} from '../../../../services/tawk-to-chat.service';

declare let ga: Function;
declare let window: any;
declare var google: any;

@Component({
  selector: 'app-offer',
  templateUrl: './offer.component.html',
})
export class OfferComponent implements OnInit, OnDestroy {
  offer: FullOffer = null;
  index = 0;
  loaded = false;
  visibleNumber = false;
  galleryImages = [];
  galleryVidImg = [];
  showVin: boolean = false;
  adobeThankyouPageData = null;
  offerNotExist = false;
  hiddenText = {
    description: true,
    equipmentStandard: true,
    equipmentOptional: true,
    technicalData: false
  };
  appComponentReference = AppComponent;
  lastFindProperties = {};
  financialProductsLabel = [];

  player = {};

  private idParamSubscription: Subscription;

  configThumb: SwiperConfigInterface = {
    loop: false,
    slidesPerView: 3,
    slidesPerGroup: 1,
    spaceBetween: 4,
    preloadImages: true,
    lazy: {
      loadPrevNext: true,
      loadPrevNextAmount: 3,
      loadOnTransitionStart: true
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    observer: true
  };
  config: SwiperConfigInterface = {
    effect: 'fade',
    followFinger: false,
    loop: false,
    preloadImages: true,
    lazy: {
      loadPrevNext: true,
      loadPrevNextAmount: 1,
      loadOnTransitionStart: true
    },
    slidesPerView: 1,
    spaceBetween: 0,
    keyboard: true,
    navigation: false,
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      clickable: true,
      hideOnClick: false
    },
    observer: true
  };
  similarOffers: Array<BasicOffer>;
  mouseDownPositionX = 0;
  mouseUpPositionX = -1;

  @Output() currentModel = new EventEmitter<string>();

  brandSlug = '';
  openBox = {
    equipmentStandard: false,
    equipmentOptional: false,
    dealerDescription: true,
  };

  constructor(
    private route: ActivatedRoute,
    private stockApi: StockApiService,
    public lightBox: CrystalLightbox,
    public stickyThing: AngularStickyThingsModule,
    public observedOffers: ObservedOfferService,
    public comparedOffers: ComparedOfferService,
    private QSS: QueryStringService,
    private LSS: LocalStorageService,
    private adobeService: AdobeService,
    private blueKaiService: BlueKaiService,
    private titleService: TitleService,
    private labelProviderService: LabelProviderService,
    private sanitizer: DomSanitizer,
    public newsletterService: NewsletterService,
  ) {
    if ($(window).width() < 980) {
      this.hiddenText.technicalData = true;
    }

    $(window).on('resize', () => {
      if ($(window).width() < 980) {
        this.hiddenText.technicalData = true;
        $($('.hidden-box[data-opt="technicalData"]')[0]).removeClass('hiddenMoreLessLinks');
      } else {
        this.hiddenText.technicalData = false;
        $($('.hidden-box[data-opt="technicalData"]')[0]).addClass('hiddenMoreLessLinks');
      }
    });

    this.offer = new FullOffer();
    this.idParamSubscription = this.route.params.subscribe(params => {
      {
        // restore default values
        this.offer = null;
        this.index = 0;
        this.loaded = false;
        this.visibleNumber = false;
        this.galleryImages = [];
        this.galleryVidImg = [];
        this.hiddenText = {
          description: true,
          equipmentStandard: true,
          equipmentOptional: true,
          technicalData: false
        };
        if ($(window).width() < 980) {
          this.hiddenText.technicalData = true;
        }
      }

      this.stockApi.getOfferData(+params['id']).then(value => { // (+) converts string 'id' to a number
        value = this.labelProviderService.fillOfferLabels(value);
        this.offer = value;

        if (BrandService.getCurrentBrand().code !== '00') {
          this.offer.equipment.standard = null;
        }
        this.galleryImages = [];
        this.galleryVidImg = [];

        if (this.offer.dealer !== null) {
          this.titleService.setTitleOffer(this.offer.model.name, this.offer.version.name, this.offer.dealer.name);
        } else {
          this.titleService.setTitleOffer(this.offer.model.name, this.offer.version.name, 'invenduto');
        }
        this.currentModel.emit(this.offer.model.group.slug);

        if (this.offer.adobeConfiguration) {
          this.adobeService.pageLoadOffer(
              this.offer.adobeConfiguration.vehicleTrim === '' ? null : this.offer.adobeConfiguration.vehicleTrim,
              this.offer.adobeConfiguration.vehicleModel === '' ? null : this.offer.adobeConfiguration.vehicleModel,
              this.offer.model.name,
              this.offer.adobeConfiguration.vehicleID === '' ? null : this.offer.adobeConfiguration.vehicleID,
              this.offer.technicalData.fuelType,
              this.offer.brand.code === '77' ? 'lcv' : 'pc',
              QSS.getParam('cid') ? QSS.getParam('cid') : this.lastFindProperties['cid']
          );

          this.adobeThankyouPageData = this.adobeService.getThankyouPageOfferData(
            this.offer.adobeConfiguration.vehicleTrim === '' ? null : this.offer.adobeConfiguration.vehicleTrim,
            this.offer.adobeConfiguration.vehicleModel === '' ? null : this.offer.adobeConfiguration.vehicleModel,
            this.offer.model.name,
            this.offer.adobeConfiguration.vehicleID === '' ? null : this.offer.adobeConfiguration.vehicleID,
            this.offer.technicalData.fuelType,
            this.offer.brand.code === '77' ? 'lcv' : 'pc',
            QSS.getParam('cid') ? QSS.getParam('cid') : this.lastFindProperties['cid']
          );
        } else {
          this.adobeService.pageLoadOffer(null, null, null, null, null,
            null, null);
          this.adobeThankyouPageData = this.adobeService.getThankyouPageOfferData(null, null, null, null, null, null, null);
        }

        this.blueKaiService.changeRoute(this.offer.model.group.name, (this.offer.dealer !== null ? this.offer.dealer.name : 'invenduto'));

        if (!AppComponent.isDealerStock && this.offer.dealer) {
          AppComponent.dealerCode = this.offer.dealer.code;
        }

        if (this.offer.financial_products.length !== 0) {
          let min_installment = -1;
          for (const item in this.offer.financial_products) {

            if (min_installment === -1) {
              min_installment = this.offer.financial_products[item].min_installment;
            }

            if (this.offer.financial_products[item].min_installment <= min_installment) {
              for (const val in this.offer.financial_products[item].parameters) {
                if (this.offer.financial_products[item].parameters[val].netto) {
                  this.financialProductsLabel['price_type'] = 'netto';
                } else {
                  this.financialProductsLabel['price_type'] = 'brutto';
                }
              }

              this.financialProductsLabel['min_installment'] = this.offer.financial_products[item].min_installment;
              this.financialProductsLabel['label'] = this.offer.financial_products[item].label;
              min_installment = this.offer.financial_products[item].min_installment;
            }
          }
        } else {
          this.financialProductsLabel = null;
        }

        if (this.offer.images.length === 0) {
          this.offer.images = [
            DefaultImagePipe.getDefaultImage(this.offer.id.toString())
          ];
        }

        if (this.offer.videos !== undefined && TrackingService.checkCookie('opncl_advertising') === 'true') {
          for (const vid of this.offer.videos) {
            this.galleryVidImg.push({
              type: 'video',
              id: vid.id,
              path: 'https://img.youtube.com/vi/' + vid.id + '/hqdefault.jpg'
            });
          }
        }

        for (const image of this.offer.images) {
          this.galleryVidImg.push({type: 'image', id: image + '?fm=pjpg', path: image + '?fm=pjpg', originUrl: image});
        }

        for (const image of this.offer.images) {
          this.galleryImages.push({path: image + '?fm=pjpg'});
        }

        const galleryOpenVideoOrImage = (type, id, path) => {
          const cgWrapper = document.querySelector('.cg-wrapper');
          if (type === 'video') {
            const host = location.protocol + '//' + location.host;
            cgWrapper.innerHTML = '<iframe id="ytplayer" style="z-index:5000; margin:0 60px;" type="text/html" ' +
              'src="https://www.youtube.com/embed/' + id + '?enablejsapi=1&rel=0&origin=' + host + '" frameborder="0"/>';
            this.onYouTubeIframeAPIReady();
          } else {
            cgWrapper.innerHTML = '<img src="' + path + '">';
          }
        };

        CrystalLightbox.prototype.open = function (images, config = {}) {

          config = this.applyConfigDefaults({
            masonry: true,
            masonryMaxHeight: 200,
            masonryGutter: 4,
            loop: false,
            index: 0,
            backgroundOpacity: 0.85,
            counter: false,
            lightboxMaxHeight: '100%',
            lightboxMaxWidth: '100%',
            animationDuration: 100
          }, config);

          const data = {
            images,
            config
          };

          const component = LightboxComponent;

          this.appendComponentToBody(component, data);

          galleryOpenVideoOrImage(images[config.index].type, images[config.index].id, images[config.index].path);

        };

        LightboxComponent.prototype.next = function() {
          this.currentImageIndex++;

          if (this.currentImageIndex >= this.data.images.length ) {
            this.currentImageIndex = 0;
          }

          galleryOpenVideoOrImage(
              this.data.images[this.currentImageIndex].type,
              this.data.images[this.currentImageIndex].id,
              this.data.images[this.currentImageIndex].path
          );
        };

        LightboxComponent.prototype.prev = function() {
          this.currentImageIndex--;

          if (this.currentImageIndex < 0 ) {
            this.currentImageIndex = this.data.images.length - 1;
          }

          galleryOpenVideoOrImage(
              this.data.images[this.currentImageIndex].type,
              this.data.images[this.currentImageIndex].id,
              this.data.images[this.currentImageIndex].path
          );
        };


        setTimeout(() => {
          this.loaded = true;
          window.dispatchEvent(new Event('resize'));
        }, 500);

        setTimeout(() => {
          $('.hidden-box').each((key, el) => {
            if ($(el).height() < 320) {
              $(el).addClass('hiddenMoreLessLinks');
              this.hiddenText[$(el).data('opt')] = false;
            } else if ($(el).data('opt') === 'technicalData' && $(window).width() >= 980) {
              $(el).addClass('hiddenMoreLessLinks');
            }
          });
        }, 300);
        TawkToChatService.enableTawkToChat(this.offer.dealer.code, true);
      }).catch(reason => {
        ErrorHandler.log(reason);
        this.offerNotExist = true;
        this.loaded = true;
      });
      this.stockApi.getSimilarOffers(
        +params['id'],
        this.appComponentReference.isDealerStock ? this.appComponentReference.dealerCode : null
      ).then(value => {
        value = this.labelProviderService.fillOfferLabelsByArray(value);
        this.similarOffers = value;
      }).catch(reason => {
        ErrorHandler.log(reason);
      });
    });

    this.showVin = QSS.getParam('showVin') !== null || QSS.getParam('showvin') !== null || QSS.getParam('ShowVin') !== null;

    $('body').on( 'touchstart', (e) => {
      if ($('.cg-wrapper').is(':visible')) {
        this.mouseDownPositionX = e.originalEvent.touches[0].clientX;
      }
    });

    $('body').on('touchmove', (e) => {
      if ($('.cg-wrapper').is(':visible')) {
        this.mouseUpPositionX = e.originalEvent.touches[0].clientX;
      }
    });

    $('body').on('touchend', () => {
      if ($('.cg-wrapper').is(':visible') &&
        this.mouseDownPositionX !== this.mouseUpPositionX &&
        this.mouseUpPositionX !== -1) {
        if (this.mouseDownPositionX - this.mouseUpPositionX > 0) {
          $('.cg-next').click();
        } else {
          $('.cg-prev').click();
        }
        this.mouseUpPositionX = -1;
      }
    });
  }

  ngOnInit() {
    setTimeout(() => {
      AppComponent.bodyClass = 'page page-offert';
    });

    this.lastFindProperties = this.LSS.get('lfprop', {});
    this.brandSlug = BrandService.getCurrentBrand().slug;
  }

  ngOnDestroy(): void {
    TawkToChatService.disableTawkToChat();
    if ($('.cg-wrapper').is(':visible')) {
      $('.cg-close').click();
    }
    this.idParamSubscription.unsubscribe();

    if (!AppComponent.isDealerStock) {
      AppComponent.dealerCode = null;
      $('#livechat-compact-container').hide(0);
      $('#livechat-eye-catcher').hide(0);
    }
  }

  selectIndex(index) {
    this.index = index;
  }

  scrollToForm = () => {
    $([document.documentElement, document.body]).animate({
      scrollTop: $('.form--offert').offset().top - 130
    }, 1000);
  }

  scrollToCommunicators = () => {
    $([document.documentElement, document.body]).animate({
      scrollTop: $('.communicators-link').offset().top - 130
    }, 1000);
  }

  scrollToFinancialProducts = () => {
    $([document.documentElement, document.body]).animate({
      scrollTop: $('.financial-products').offset().top - 130
    }, 700);
  }

  share() {
    ShareComponent.openModal();
    this.sendGA('send', 'event', 'link', 'click', 'share');
  }

  hasLastFindProperties(): boolean {
    return Object.keys(this.lastFindProperties).length > 0;
  }

  showPhone() {
    this.visibleNumber = true;
    this.blueKaiService.click2call();
    this.sendGA('send', 'event', 'link', 'click', 'showPhoneNumber');

    if (environment.version !== 'dev' && TrackingService.isEnabled(TrackingService.SIZMEK) &&
        TrackingService.isOpenclPerformanceCookieEnabled()) {
      switch (this.offer.brand.code) {
        case '00':
          this.sendSizmek('1147896');
          break;
        case '77':
          this.sendSizmek('1455114');
          break;
        case '83':
          this.sendSizmek('1455113');
          break;
        case '57':
          this.sendSizmek('1455115');
          break;
        case '66':
          this.sendSizmek('1457909');
          break;
      }
    }


    if (environment.version !== 'dev' && TrackingService.isEnabled(TrackingService.GTM) &&
        TrackingService.isOpenclPerformanceCookieEnabled()) {
      switch (this.offer.brand.code) {
        case '00':
          this.sendGtm('10176142', 'fiatnume', 'plfianum');
          break;
        case '77':
          this.sendGtm('10176142', 'lcvnume', 'pllcvnum');
          break;
        case '83':
          this.sendGtm('10176142', 'alfanume', 'plalfnum');
          break;
        case '57':
          this.sendGtm('10176142', 'jeepnume', 'pljeepnu');
          break;
        case '66':
          this.sendGtm('10176142', 'pokaznum', 'abartnum');
          break;
      }
    }
  }

  sendSizmek(activityID) {
    const cookieSessionId = this.getCookieSessionId();
    if (cookieSessionId !== 'false') {
      const ebSession = cookieSessionId;
      let ebRand: any = Math.random() + '';
      ebRand = ebRand * 1000000;

      const newScript = document.createElement('script');
      newScript.type = 'text/javascript';
      newScript.src = 'https://bs.serving-sys.com/Serving/ActivityServer.bs?cn=as&ActivityID=' + activityID + '&rnd='
          + ebRand + '&Session=' + ebSession;
      document.body.appendChild(newScript);
    }
  }

  sendGtm(activityID, type, cat) {
    if ($('.iframe-gtm').length) {
      $( '.iframe-gtm' ).remove();
    }

    const axel: any  = Math.random() + '';
    const a = axel * 10000000000000;
    const newIframe = document.createElement('iframe');
    newIframe.height = '1';
    newIframe.width = '1';
    newIframe.style.display = 'none';
    newIframe.className = 'iframe-gtm';

    newIframe.src = 'https://' + activityID + '.fls.doubleclick.net/activityi;src=' + activityID + ';type=' + type + ';cat=' + cat +
        ';dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;npa=;gdpr=${GDPR};gdpr_consent=${GDPR_CONSENT_755};ord=' + a + '?;';
    document.body.appendChild(newIframe);

  }

  getCookieSessionId(): string {
    const name = 'PHPSESSID';
    const nameLenPlus = (name.length + 1);
    const value = document.cookie
        .split(';')
        .map(c => c.trim())
        .filter(cookie => {
          return cookie.substring(0, nameLenPlus) === `${name}=`;
        })
        .map(cookie => {
          return decodeURIComponent(cookie.substring(nameLenPlus));
        })[0] || null;
    if (value !== 'false') {
      return value;
    } else {
      return 'false';
    }
  }

  onYouTubeIframeAPIReady() {
    this.player = new window.YT.Player( 'ytplayer', {
      events: { 'onStateChange': this.onPlayerStateChange }
    });
  }

  onPlayerStateChange(event) {
    if (event.data === 0) {
      event.target.stopVideo();
    }
  }
  setDefaultImg140x76(event) {
    event.target.src = '/assets/img/default_img_140x76.png';
  }
  setDefaultImg800x600(event) {
    if (event.currentTarget && event.currentTarget.parentElement) {
      event.currentTarget.parentElement.innerHTML = '<img src="/assets/img/default_img_800x600.png" class="box-model__photo-img" />';
    }
  }

  sanitize(url: string) {
    return this.sanitizer.bypassSecurityTrustUrl(url);
  }

  sendGA(event: string, eventCategory: string, eventAction: string, eventLabel: string, eventValue: string) {
    if (TrackingService.isEnabled(TrackingService.GOOGLE_ANALYTICS) && typeof ga !== 'undefined') {
      ga(event, eventCategory, eventAction, eventLabel, eventValue);
    }
  }

  showComunicators() {
    if (['fiat', 'fiat-professional', 'abarth'].indexOf(this.brandSlug) > -1) {
      let show = false;
      for (const item in this.offer.dealer.communicators) {
        if (this.offer.dealer.communicators[item].name === 'Messenger' || this.offer.dealer.communicators[item].name === 'WhatsApp' ) {
          show = true;
        }
      }
      return show;
    } else {
      return true;
    }
  }

  initMap(lat, lng) {
    setTimeout(() => {
      const uluru = { lat, lng };
      const map = new google.maps.Map(document.getElementById("map"), {
        zoom: 12,
        center: uluru,
      });

      const marker = new google.maps.Marker({
        position: uluru,
        map: map,
      });
    }, 200);
  }
}
